import { motion } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from "react-router-dom";
import BackArrow from './images/images-home/BackArrow';
import HomeSVG from './images/images-home/HomeSVG';


const GeneralInfo = ({isInIFrame}) => {

    const navigate = useNavigate()

    const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1350px)'})

    
    return (  
        <div className="genericContent-container">
            <motion.div className='genericContent-innerContainer'
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 1 }}
                style={{
                    height: isInIFrame ? '100vh' : '',
                    top: isInIFrame ? '0px' : '',
                    scrollbarColor: isInIFrame ? 'auto' : ''
                }}
            >
                {isInIFrame &&  
                    <div className='homeIcon-iframeContainer'
                        onClick={() => navigate('-1')}
                        style={{
                            position: 'fixed',
                            top: '11px',
                            right: '4%',
                            zIndex: 99,
                            cursor: 'pointer'
                        }}
                    >
                        <BackArrow />
                    </div>
                }
                {(!isInIFrame && isDesktopOrLaptop) &&
                    <div className='homeIcon-iframeContainer'
                        onClick={() => navigate('-1')}
                        style={{
                            position: 'fixed',
                            top: '81px',
                            left: '30px',
                            zIndex: 99,
                            cursor: 'pointer'
                        }}
                    >
                        <HomeSVG size={"2em"} color={"#ffffff"}/>
                    </div>
                }
                <div className='genericContent-text'>
                    <h1 className='content-header'
                        style={{
                            paddingTop: isInIFrame ? '5px' : ''
                        }}
                    >רקע כללי</h1>
                    <p className='content-paragraph'>שדה נחמיה הוא קיבוץ בצפון עמק החולה השייך למועצה האזורית הגליל העליון. הקיבוץ נמצא כ- 6 ק"מ מזרחית לקריית שמונה, על מפגש הנחלים חרמון (בניאס) ושניר (חצבאני), המתמזגים עם נחל הדן ליצירת נהר הירדן.</p><br/><p className='content-paragraph'>הקיבוץ הוקם בדצמבר 1940 על ידי הקבוצה ההולנדית "חוליות", שהגיעה לארץ להכשרה, אליה הצטרפו בהמשך עולים נוספים מאוסטריה ומצ'כיה. <br/>כשנתיים מעליית הקיבוץ לקרקע, הוחלט לקרוא לו "שדה נחמיה- חוליות", על שם הגרעין שהקים אותו ועל שם המנהיג הציוני ההולנדי "נחמיה דה-לימה", שכיהן כיו"ר סניף ההסתדרות הציונית העולמית בהולנד, כחבר בוועד הפועל של ההסתדרות הציונית וכחבר בדירקטוריון קק"ל. <br/>כאשר מפעל הפלסטיק של הקיבוץ הוקם בשנת 1947, הוחלט לקרוא למפעל "חוליות", ולצמצם את שם הקיבוץ ל"שדה נחמיה". <br/>על אף שינוי זה, עד היום רבים מבני דור ההקמה, עדיין מכנים את הקיבוץ בשם "חוליות".</p><br/><p className='content-paragraph'>הקיבוץ פעל לאורך השנים כ"קיבוץ שיתופי". בשנת 2002 החל הקיבוץ תהליך הפרטה ושינה סיווגו ל"קיבוץ מתחדש". כחלק מהמעבר לקיבוץ מתחדש, הקיבוץ עבר תהליך הפרטה, שבו האחריות לפרנסה עברה אל הפרט, ובנוסף הבתים עברו מבעלות הקיבוץ לבעלות פרטית של חברי הקיבוץ. כיום, אותם חברים מאוגדים תחת אגודה שיתופית חקלאית (האגש"ח), אשר מנהלת הן את ענייניהם הכלכליים המשותפים (מפעל חוליות, לולים, חקלאות ודירות להשכרה) והן את מנגנון הערבות ההדדית, אשר מספק רשת ביטחון לחבריה (צרכים מיוחדים, אובדן כושר עבודה, פנסיה וכו').</p><br/><p className='content-paragraph'>במקביל לתהליך ההפרטה, בעקבות הצטמצמות והתבגרות האוכלוסיה והרצון להצעיר את הקיבוץ, הוחלט על הקמת הרחבה גדולה שהגדילה משמעותית את הקהילה והוסיפה ל- 200 חברי הקיבוץ עוד 150 בתי אב. אבן הפינה להרחבה הונחה בשנת 2004.</p><br/><p className='content-paragraph'>הן חברי האגש"ח והן תושבי ההרחבה הם חברים באגודה המוניציפלית (האג"ם), אשר אחראית על כל תחומי החיים בקיבוץ- החברתיים, הקהילתיים, החינוכיים והמוניציפליים. האגודה מנוהלת על ידי מנהלת קהילה, כאשר וועד ההנהלה של היישוב, שנבחר על ידי התושבים המתגוררים בשדה נחמיה, קובע את המדיניות (הבחירות לוועד ההנהלה מתקיימות פעם בשנתיים).</p><br/><p className='content-paragraph'>הגוף העליון של האג"ם זו "אסיפת החברים" שמתכנסת פעמיים בשנה או יותר על פי הצורך. האסיפה מורכבת מכלל חברי האג"מ של שדה נחמיה ועוסקת בדברים המשפיעים על אורחות החיים, ולאחריה יש הצבעה של כל היישוב בקלפי אונליין.</p><br/><p className='content-paragraph'>כל חברי האג"מ מוזמנים להתמודד בבחירות לוועד ההנהלה, וכמו כן הם מוזמנים ליזום או לקחת חלק ולהשתלב בפעילויות החברתיות והקהילתיות השונות ביישוב, ולהפוך לחלק פעיל בקהילה המגובשת של שדה נחמיה.</p>
                </div>
                <br/><br/><br/>
                {/* <div class="infoFooter"><a href="mailto:michal.diminsky@gmail.com">האתר פותח על ידי מיכל דימינסקי צרפתי</a></div> */}
            </motion.div>
        </div>
    );
}
 
export default GeneralInfo;